import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withTranslation, Trans } from 'react-i18next';
import moment from 'moment';

class TokenExpired extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active : false,
            style : {
                display : 'none'
            }
        };
    }

    componentDidMount() {
        this.setState({
            ...this.state,
            style : {
                display : 'block'
            }
        });
		document.documentElement.classList.add('modal-open');

		//this.setScrollbarWidth();
        let shouldRedirectToWelcomePage = false;
        const { error } = this.props;
        if(error) {
            switch(error.type) {
                case 'NO_PERMISSION_TO_VIEW_PAGE':
                case 'NO_SITE_ACCESS':
                    shouldRedirectToWelcomePage = false;
                    break;
                default:
                    shouldRedirectToWelcomePage = true;
                    break;
            }
        }
        setTimeout(() => {
            this.setState({
                ...this.state,
                active : true,
                shouldRedirectToWelcomePage
            });
        }, 500);
    }

    close = () => {
        this.setState({
            ...this.state,
            active : false
        });

        document.documentElement.classList.remove('modal-open');
		//document.body.style.paddingRight = '';
	};

	setScrollbarWidth = () => {
		//document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
		document.documentElement.classList.add('modal-open');
	};

	getScrollbarWidth = () => {
		let widthNoScroll = '';
		let inner = '';
		let widthWithScroll = '';
		let outer = document.createElement("div");

		outer.style.visibility = "hidden";
		outer.style.width = "100px";
		document.body.appendChild(outer);

		widthNoScroll = outer.offsetWidth;
		outer.style.overflow = "scroll";

		inner = document.createElement("div");
		inner.style.width = "100%";
		outer.appendChild(inner);

		widthWithScroll = inner.offsetWidth;
		outer.parentNode.removeChild(outer);

		return widthNoScroll - widthWithScroll;
    };

    renderMessage = () => {
        const {
            error,
            t
        } = this.props;
        if (error && error.type === 'REVOKED_BY_NEW_LOGIN') {
            return (
                // 동일계정로그인
                <div className="message-description">
                    <i className="sprite sprite-notification"></i>
                    <div>
                        <p><strong className="text-primary">{t(`common::msg::${"Duplicate login status."}`)}</strong></p>
                        <strong>{t(`common::msg::${"You are currently logged in from another web browser with your information, the connection is terminated and you are directed to the welcome page."}`)}</strong>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="message-description">
                    <i className="sprite sprite-notification"></i>
                    <div>
                        {error && error.type === 'NO_PERMISSION_TO_VIEW_PAGE' &&
                            <p>
                                <strong>{t(`common::msg::${"You have no permission to view this page."}`)}</strong><br/>
                            </p>
                        }
                        {error && error.type === 'NO_SITE_ACCESS' &&
                            <p>
                                <strong>{t(`common::msg::${"You have no site access."}`)}</strong><br/>
                                <strong>{t(`common::msg::${"If you want to site access, please contact your space manager."}`)}</strong>
                            </p>
                        }
                        {error && error.type === 'EXPIRED_USER' &&
                            <p><strong className="text-primary">{t(`common::msg::${"Your account has been expired."}`)}</strong></p>
                        }
                        {error && error.type === 'INACTIVATED_USER' &&
                            <p><strong className="text-primary">{t(`common::msg::${"Your account has been inactivated."}`)}</strong></p>
                        }
                        {error && error.type === 'DELETED_USER' &&
                            <p><strong className="text-primary">{t(`common::msg::${"Your account has been deleted."}`)}</strong></p>
                        }
                        {this.state.shouldRedirectToWelcomePage === true &&
                            <strong>
                                <Trans
                                    i18nKey="common::msg::You cannot access the project.<0/>The connection is terminated and you are directed to the welcome page."
                                    components={[<br/>]}
                                />
                            </strong>
                        }
                        {error && error.type === 'EXPIRED_USER' && error.expiredAt &&
                            <div className="bpx">
                                <strong className="dot">{t(`common::msg::${"Expired date :"}`)}</strong>
                                <strong className="text-danger">{error.expiredAt && moment(error.expiredAt).format("YYYY-MM-DD")}</strong>
                            </div>
                        }
                        {error && !error.type === 'NO_SITE_ACCESS' &&
                        <>
                            <hr/>
                            <strong>{t(`common::msg::${"Please contact your space manager."}`)}</strong>
                        </>
                        }
                    </div>
                </div>
            )
        }
    }

    render() {
        const {
            confirmButtonText,
            t,
        } = this.props;

        //console.log(this.props);

        return (
            <div
                className={`modal fade ${this.state.active ? 'show' : ''}`}
                style={this.state.style}
                onTransitionEnd={() => {
                    if(!this.state.active) {
                        this.props.onClose();
                    }
                }}>
                <div className={"modal-dialog modal-token"}>
                    <div className={"modal-header"}>
                        <h5 className={"modal-title"}>
                            {t(`common::label::${"Warning"}`)}
                        </h5>
                        {/* <button type={"button"}
                                className={"close"}
                                onClick={(e) => {
                                    this.close();
                                }}>
                            <i className={"sprite sprite-cancel-lg"}/>
                        </button> */}
                    </div>
                    <div className={"modal-body"}>
                        {/* TODO: token */}
                        {/* 자동로그아웃 */}
                        {/* <div className={"message-description"}>
                            <i className={"sprite sprite-notification"}></i>
                            <div>
                                <p><strong className="text-primary">Coming soon to auto logout.</strong></p>
                                <strong>After logging in, if there is no use such as clicking a menu on the console for about 10 minutes, you are automatically logged out.</strong>
                                <div className="box box-error">
                                    <i className="sprite sprite-clock-fade"></i>
                                    <strong>Time Remaining : </strong>
                                    <strong className="text-danger"><strong className="text-">52</strong>sec</strong>
                                </div>
                                <strong>Would you like to extend your login time?</strong>
                            </div>
                        </div> */}
                        {/* 자동로그아웃 */}
                        {this.renderMessage()}
                    </div>
                    <div className={"modal-footer"}>
                        {/* <button
                            type={"button"}
                            className={"btn btn-outline-dark"}
                            onClick={(e) => {
                                this.close();
                            }}>
                            {t(`common::label::${"Cancel"}`)}
                        </button> */}
                        <button
                            type={"button"}
                            className={"btn btn-primary"}
                            onClick={(e) => {
                                this.close();
                                this.props.onConfirm();
                            }}>
                            {confirmButtonText || t(`common::label::${"Confirm"}`)}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

let mapStateToProps = (state) => {
    return {
        global : state.global
    };
};

TokenExpired = connect(mapStateToProps)(TokenExpired);

export default withTranslation()(TokenExpired);
